import { render, staticRenderFns } from "./TransmitDialog.vue?vue&type=template&id=6a135b6e"
import script from "./TransmitDialog.vue?vue&type=script&lang=js"
export * from "./TransmitDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports